/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'sysque-switch-with-label-v',
  templateUrl: './switch-with-label-v.component.html',
  styleUrls: ['./switch-with-label-v.component.scss'],
  standalone: false
})
export class SwitchWithLabelVComponent {
  @Input() label;
  @Input() value;
  @Output() onProcessToggleChange = new EventEmitter();
  items = [];

  constructor() {
    this.value = this.value?.bind(this);
    this.label = this.label?.bind(this);
  }

  switchClick(e: any) {
    this.items = [];
    this.items.push(this.label, e.detail);
    this.onProcessToggleChange.emit(this.items);
  }
}
